<div
    [ngClass]="
        styleType === 'rounded'
            ? 'tv-year-picker-round-extensible-no-label-no-border'
            : 'tv-square-input-for-date-pickers-no-label'
    ">
    <mat-form-field class="tv-date-range-picker">
        <input [formControl]="yearFormControl" [matDatepicker]="yearDatepicker" [readonly]="true" matInput [max]="2032" name="year" />
        <mat-datepicker-toggle [for]="yearDatepicker" class="icon-style" matPrefix></mat-datepicker-toggle>
        <mat-datepicker
            #yearDatepicker
            id="yearDatepicker"
            (yearSelected)="handleYearDatepickerValueChange($event, yearDatepicker)"
            [startView]="'multi-year'">
        </mat-datepicker>
    </mat-form-field>
</div>
